import React from 'react';
import { useNavigate } from 'react-router-dom';
import SEOHead from '../components/Common/SEOHead';
import bannerImage from '../../images/HomePage/Mr.Sea_HomePage_HeroImage.png';
import '../styles/notfound/NotFoundPage.css';

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <div className="not-found-page">
      <SEOHead pageType="404" />
      <div className="not-found-hero">
        <div className="not-found-hero__bg-image" style={{ backgroundImage: `url(${bannerImage})` }}></div>
        <div className="not-found-hero__overlay"></div>
        <div className="not-found-container">
          <h1 className="not-found-title">What you're looking for was not found</h1>
          <button 
            className="button not-found-button" 
            onClick={() => navigate('/')}
          >
            Go to Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;

